import { Button, ButtonProps, MenuButton, useBreakpointValue } from "@chakra-ui/react"
import { truncateTextInMiddleConstants } from "../../../../../../../common/constants/constants"
import { truncateTextInMiddle } from "../../../../../../../common/utils/search-utils"
import { CCheck, CChevronDown, CChevronRight, CChevronUp } from "../../../../../../shared/Icons"

const { FILTER_BOX_SELECT_SM, FILTER_BOX_SELECT_MD, FILTER_BOX_SELECT_DESKTOP } = truncateTextInMiddleConstants

type Props = ButtonProps & {
  title: string
  isOpen: boolean
  isFilterSelected: boolean
  isOverlayFilters?: boolean
  onClick?: () => void
}

const FilterButton = ({ title, isOpen, isFilterSelected, isOverlayFilters = false, onClick, ...rest }: Props) => {
  const filterSelectTextTruncationNumber = useBreakpointValue({
    base: FILTER_BOX_SELECT_SM,
    sm: FILTER_BOX_SELECT_MD,
    md: FILTER_BOX_SELECT_DESKTOP,
  })

  const ButtonType = isOverlayFilters ? Button : MenuButton

  return (
    <ButtonType
      as={Button}
      h={isOverlayFilters ? "11" : "10"}
      py="3"
      pl="2"
      pr={isOverlayFilters ? "3" : isFilterSelected ? "3" : "2.5"}
      rightIcon={
        isFilterSelected ? (
          <CCheck />
        ) : isOverlayFilters ? (
          <CChevronRight />
        ) : isOpen ? (
          <CChevronUp />
        ) : (
          <CChevronDown />
        )
      }
      iconSpacing={isFilterSelected ? "3" : "2.5"}
      fontWeight="medium"
      fontSize="xs"
      color="black"
      bgColor={isFilterSelected && "gray.300"}
      variant="dropdown"
      justifyContent="space-between"
      w={isOverlayFilters ? "100%" : "auto"}
      onClick={onClick}
      {...rest}
    >
      {truncateTextInMiddle(title, filterSelectTextTruncationNumber)}
    </ButtonType>
  )
}

export default FilterButton
